export default "__VITE_ASSET__BOXN$K2y__"